import APIService from './APIService'
import { dissoc } from 'ramda'

const api = APIService()
const pendingGetRequests = new Map()

const dedupePendingGet = (key, requestFactory) => {
  if (pendingGetRequests.has(key)) {
    return pendingGetRequests.get(key)
  }

  const request = requestFactory().finally(() => {
    if (pendingGetRequests.get(key) === request) {
      pendingGetRequests.delete(key)
    }
  })

  pendingGetRequests.set(key, request)
  return request
}

export const getAnalyticsTemplates = () =>
  dedupePendingGet('analytics-templates', () => api.get('/analytics-templates'))

export const getBpsWithAnalytics = payload => {
  const page = typeof payload === 'object' ? payload.page : payload
  const includeDormant = typeof payload === 'object' && payload.includeDormant
  const params = new URLSearchParams({
    page: page || 1,
    limit: 10,
    include_dormant: includeDormant ? 1 : 0
  })

  return dedupePendingGet(
    `building-passport/analytics:${params.toString()}`,
    () => api.get(`/building-passport/analytics?${params.toString()}`)
  )
}

export const getAnalyticsSharingInvitations = () =>
  dedupePendingGet(
    'analytics-templates/sharing-invitations',
    () => api.get('/analytics-templates/sharing-invitations')
  )

export const acceptAnalyticsSharingInvitation = payload => api.patch(`/analytics-templates/${payload}/share`)

export const rejectAnalyticsSharingInvitation = payload => api.delete(`/analytics-templates/${payload}/share`)

export const createAnalyticsTemplate = payload => api.post('/analytics-templates', payload)

export const updateAnalyticsTemplate = payload => api.patch(`/analytics-templates/${payload.id}`, dissoc('silentSuccess', dissoc('id', payload)))

export const duplicateAnalyticsTemplate = payload => api.post(`/analytics-templates/${payload.id}/duplicate`)

export const shareAnalyticsTemplate = ({ templateId, userId }) =>
  api.post(`/analytics-templates/${templateId}/share`, { userId, user_id: userId })

export const removeAnalyticsTemplate = payload => api.delete(`/analytics-templates/${payload.id}`)

export const attachAnalyticsTemplate = ({ bpId, templateId, visibility, item_tag_requirements }) =>
  api.post(`/building-passport/${bpId}/analytics-template/${templateId}`, {
    visibility,
    item_tag_requirements
  })

export const updateAttachedAnalyticsTemplateTagRequirements = ({ bpId, templateId, item_tag_requirements }) =>
  api.patch(`/building-passport/${bpId}/analytics-template/${templateId}/tag-requirements`, {
    item_tag_requirements
  })

export const detachAnalyticsTemplate = ({ bpId, templateId }) =>
  api.delete(`/building-passport/${bpId}/analytics-template/${templateId}`)

export const attachAnalyticsTemplateToAllBps = ({ templateId, building_passport_ids, attach_to_all_users }) =>
  api.post(`/analytics-templates/${templateId}/attach-to-all-my-building-passports`, {
    building_passport_ids,
    attach_to_all_users,
  });

export const getActiveBuildingPassports = () => api.get('/building-passport/active');
